<template>
  <article class="ceo-wrapper container">
    <div class="title-con">
      <img :src="thumbnail" alt="img" />
      <div class="text">
        <a :href="'/CeoDetail?idx='+idx" target="_blank"
          >{{ title }}<br /><span>{{ magazine_name}}</span></a
        >
      </div>
    </div>
    <div class="list-con">
      <p>CEO Message</p>
      <ul>
        <li v-for="(item, c) in messageList"
          :key="c">
          <a :href="'/CeoDetail?idx='+item.idx" target="_blank">{{ item.title }}</a>
          <p>{{ item.magazine_name }}</p>
        </li>
      </ul>
    </div>
  </article>
</template>
<script>
export default {
  name: "Ceo",
  data() {
    return {
      idx: "",
      magazine_name: "",
      thumbnail:"",
      title: "",
      file1_url: "",
      messageList:[],
    };
  },
  mounted() {
    this.getCeomessage();
    this.getCeomessageList();
  },
  methods: {
    // 메세지 상세 데이터 불러오기
    getCeomessage() {

    axios
      .get("/rest/external/getCeomessage")
      .then((res) => {
        if (res.data.err == 0) {
          this.magazine_name = res.data.magazine_name;
          this.title = res.data.title_ko;
          this.thumbnail = res.data.thumbnail;
          this.idx = res.data.idx;
        } else {
          console.error("res.data.err : ", res.data.err);
        }
      })
      .catch((err) => {
        alert("통신이 원활하지 않습니다.");
        console.error("err : ", err);
      });
    },

    getCeomessageList() {
      const params = {
        limit: 3,
      };
      axios
      .get("/rest/external/getCeomessages", {params: params})
      .then((res) => {
        if (res.data.err == 0) {
          this.messageList = res.data.list;
        } else {
          console.error("res.data.err : ", res.data.err);
        }
      })
      .catch((err) => {
        alert("통신이 원활하지 않습니다.");
        console.error("err : ", err);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.ceo-wrapper {
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 20px 0;

  .title-con {
    position: relative;
    width: 100%;

    img {
      width: inherit;
      height: 100%;
    }

    .text {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 26px 10px;
      background: rgba(0, 0, 0, 0.4);

      a {
        font-size: 24px;
        font-style: italic;
        color: #ffffff;

        span {
          font-size: 13px;
        }
      }
    }
  }

  .list-con {
    flex-grow: 1;

    > p {
      font-size: 33px;
      font-weight: bold;
      color: #232323;
      margin-bottom: 20px;
    }

    > ul {
      li {
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 12px;
        margin-bottom: 12px;

        &:last-child {
          border-bottom: 0 none;
          padding-bottom: 0;
          margin-bottom: 0;
        }

        a {
          font-size: 17px;
          color: #232323;
          margin-bottom: 12px;
        }

        p {
          font-size: 15px;
          color: #676767;
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .ceo-wrapper {
    padding: 80px 0;
    flex-direction: row;
    gap: 0 40px;

    .title-con {
      width: 50%;

      img {
        width: 100%;
      }
    }

    .list-con {
      width: 50%;

      > p {
        font-size: 50px;
      }

      > ul {
        li {
          a {
            font-size: 19px;
          }

          p {
            font-size: 18px;
            color: #676767;
          }
        }
      }
    }
  }
}
</style>
